import { Component, Input, OnInit } from '@angular/core';
import { AppModule } from '@core/constants/module-history.constants';

@Component({
    selector: 'rol-menu-toolbar',
    templateUrl: './menu-toolbar.component.html',
    styleUrls: ['./menu-toolbar.component.scss'],
    standalone: false,
})
export class MenuToolbarComponent implements OnInit {
    @Input() routes: AppModule[];

    constructor() {}

    ngOnInit(): void {}
}
